// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"profile-chunk","268":"prodotti-chunk","309":"default-chunk","667":"scVar-chunk","855":"storOrd-chunk","889":"carrello-chunk"}[chunkId] + "." + {"177":"f3552e68","268":"f0364cb9","309":"201eef44","667":"50d9c81f","855":"1adcfa05","889":"c6b1e0d2"}[chunkId] + ".css";
};